import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function PasswordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const hasAtLeastOneLetter = /[a-zA-Z]+/.test(value);

    const hasAtLeastOneNumber = /[0-9]+/.test(value);

    const validPassword = hasAtLeastOneLetter && hasAtLeastOneNumber;

    return !validPassword
      ? {
          passwordStrength: {
            valid: false,
          },
        }
      : null;
  };
}
